<template>
    <a-card :bordered="false">
        <s-table ref="table" size="default" :columns="columns" :data="loadData">
            <template slot="type" slot-scope="text">
                {{ text | skuRecordFilter }}
            </template>
        </s-table>
    </a-card>
</template>
<script>
import STable from "@/components/table/";
import { gettMallGoodsSkuRecord } from "@/api/mall";

export default {
    components: {
        STable
    },
    filters: {
        skuRecordFilter: function (value) {
            //操作类型0、下架 1、上架 2、增加库存 3、减少库存 4、用户下单减扣 5、用户取消订单增加 6、管理员删除
            switch (value) {
                case 0:
                    return "下架";
                case 1:
                    return "上架";
                case 2:
                    return "增加库存";
                case 3:
                    return "减少库存";
                case 4:
                    return "用户下单减扣";
                case 5:
                    return "用户取消订单增加";
                case 6:
                    return "管理员删除";
                default:
                    return "未知";
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    title: "操作时间",
                    dataIndex: "created",
                    key: "created"
                },
                {
                    title: "操作数量",
                    dataIndex: "num",
                    key: "num"
                },
                {
                    title: "操作人",
                    dataIndex: "admin_user_name",
                    key: "admin_user_name"
                },
                {
                    title:"操作用户",
                    dataIndex:"nick_name",  
                    key:"nick_name"
                },
                {
                    title: "操作内容",
                    dataIndex: "type",
                    key: "type",
                    scopedSlots: { customRender: "type" }
                },
                {
                    title:"备注",
                    dataIndex:"remark",
                    key:"remark"
                }
               
            ],
            loadData: (params) => {
                return gettMallGoodsSkuRecord(params,this.$route.params.id).then(
                    (res) => res
                );
            },
        };
    },
    created() {
    
    }
};

</script>